import styled from "@emotion/styled";
import { Button } from "@mui/material";

const PanelButton = styled(Button)(() => ({
  height: "26px",
  fontSize: "13px",
})) as typeof Button;

export default PanelButton;
